export const categories = [
  { id: 'dailysai', slug: 'meiri-dasai', name: '每日大赛', description: '每日最新爆料大赛，精彩不断', icon: 'ri-fire-line' },
  { id: 'celebrity', slug: 'mingxing-bagua', name: '明星八卦', description: '娱乐圈明星最新动态', icon: 'ri-star-line' },
  { id: 'influencer', slug: 'wanghong-baoliao', name: '网红爆料', description: '网红圈独家内幕揭秘', icon: 'ri-user-smile-line' },
  { id: 'hotspot', slug: 'redian-shendu', name: '热点深度', description: '深度解读圈内热点事件', icon: 'ri-flashlight-line' },
  { id: 'encyclopedia', slug: 'heiliaobaike', name: '黑料百科', description: '海量黑料知识库', icon: 'ri-book-open-line' },
  { id: 'exclusive', slug: 'dujia-ziyuan', name: '独家资源', description: '全网独家一手资料', icon: 'ri-lock-line' },
];

export const articles = [
  {
    id: 1,
    title: '某知名男星深夜密会神秘女子，两人现身私人会所举止亲密',
    slug: 'zhiming-nanxing-shenye-mihui',
    category: 'celebrity',
    categoryName: '明星八卦',
    summary: '据知情人士透露，该男星近期正在与某当红小花传绯闻，此次深夜密会让人大跌眼镜。现场目击者称两人在会所停留近三个小时。',
    content: '详细内容待补充...',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20two%20silhouettes%20at%20night%20entrance%20of%20luxury%20club%2C%20mysterious%20atmosphere%2C%20dramatic%20lighting%2C%20paparazzi%20style%20photography%2C%20warm%20neon%20accents%2C%20film%20grain%2C%20editorial%20quality&width=800&height=600&seq=article-cover-01&orientation=landscape',
    tags: ['明星', '八卦', '独家'],
    views: 128500,
    hot: 98,
    isFeatured: true,
    isDaily: true,
    publishDate: '2026-07-06',
  },
  {
    id: 2,
    title: '某选秀节目导师私下评价曝光，直言某选手全靠背景晋级',
    slug: 'xuanxiu-daoshi-pingjia-baoguang',
    category: 'hotspot',
    categoryName: '热点深度',
    summary: '一份疑似节目内部聊天记录在网络疯传，多位导师对选手真实评价令人震惊，节目组至今未回应。',
    content: '详细内容待补充...',
    coverImage: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20performance%20scene%20with%20spotlight%20and%20dark%20surroundings%2C%20tension%20atmosphere%2C%20music%20competition%20show%20vibe%2C%20editorial%20photography%2C%20high%20contrast%2C%20moody%20lighting%2C%20professional%20quality&width=800&height=600&seq=article-cover-02&orientation=landscape',
    tags: ['选秀', '内幕', '导师'],
    views: 96200,
    hot: 85,
    isFeatured: false,
    isDaily: true,
    publishDate: '2026-07-06',
  },
  {
    id: 3,
    title: '某平台头部网红被曝虚假人设，真实身份与网络形象天差地别',
    slug: 'wanghong-xujia-renshe-baoguang',
    category: 'influencer',
    categoryName: '网红爆料',
    summary: '拥有千万粉丝的某知名网红被前合作伙伴爆料，其精心打造的励志人设背后另有真相，粉丝集体破防。',
    content: '详细内容待补充...',
    coverImage: 'https://readdy.ai/api/search-image?query=Split%20portrait%20concept%20with%20glamorous%20social%20media%20influencer%20on%20one%20side%20and%20dark%20hidden%20reality%20on%20the%20other%2C%20double%20exposure%20style%2C%20dramatic%20contrast%2C%20editorial%20fashion%20photography%2C%20moody%20cinematic%20lighting&width=800&height=600&seq=article-cover-03&orientation=landscape',
    tags: ['网红', '人设', '虚假'],
    views: 156800,
    hot: 92,
    isFeatured: true,
    isDaily: true,
    publishDate: '2026-07-05',
  },
  {
    id: 4,
    title: '某综艺节目录制现场突发意外，嘉宾当场翻脸离场',
    slug: 'zongyi-luzhi-yiwai-jiabin',
    category: 'celebrity',
    categoryName: '明星八卦',
    summary: '据悉是因为节目组临时更改游戏规则导致嘉宾不满，现场气氛一度十分尴尬，其他嘉宾面面相觑。',
    content: '详细内容待补充...',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20bright%20lights%20and%20cameras%2C%20tense%20atmosphere%2C%20people%20standing%20in%20confrontation%2C%20reality%20show%20production%20scene%2C%20dramatic%20moment%2C%20editorial%20photography%2C%20high%20production%20value&width=800&height=600&seq=article-cover-04&orientation=landscape',
    tags: ['综艺', '事故', '翻脸'],
    views: 89200,
    hot: 78,
    isFeatured: false,
    isDaily: false,
    publishDate: '2026-07-05',
  },
  {
    id: 5,
    title: '深度起底某影视公司资本运作，旗下艺人合约暗藏玄机',
    slug: 'yingshi-gongsi-ziben-yunzuo',
    category: 'hotspot',
    categoryName: '热点深度',
    summary: '一份被泄露的内部文件揭示了某知名影视公司对旗下艺人的苛刻合约条款，多位艺人疑似被变相限制人身自由。',
    content: '详细内容待补充...',
    coverImage: 'https://readdy.ai/api/search-image?query=Corporate%20office%20interior%20with%20dramatic%20shadows%2C%20business%20documents%20scattered%20on%20desk%2C%20mysterious%20atmosphere%2C%20financial%20investigation%20theme%2C%20dark%20cinematic%20lighting%2C%20film%20noir%20style%2C%20high%20quality&width=800&height=600&seq=article-cover-05&orientation=landscape',
    tags: ['资本', '合约', '艺人生存'],
    views: 67300,
    hot: 72,
    isFeatured: false,
    isDaily: false,
    publishDate: '2026-07-04',
  },
  {
    id: 6,
    title: '某知名导演新片选角内幕：某流量明星靠关系挤掉实力派',
    slug: 'daoyan-xuanjiao-neimu-liuliang',
    category: 'encyclopedia',
    categoryName: '黑料百科',
    summary: '据剧组内部人员透露，原本已经确定的主演在开拍前被临时替换，背后的资本博弈令人唏嘘。',
    content: '详细内容待补充...',
    coverImage: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20dramatic%20spotlight%20illuminating%20empty%20scene%2C%20movie%20production%20backdrop%2C%20tension%20and%20mystery%20atmosphere%2C%20cinematic%20photography%2C%20professional%20lighting&width=800&height=600&seq=article-cover-06&orientation=landscape',
    tags: ['导演', '选角', '潜规则'],
    views: 104300,
    hot: 88,
    isFeatured: true,
    isDaily: true,
    publishDate: '2026-07-04',
  },
  {
    id: 7,
    title: '某女星被拍到素颜逛菜市场，与精修图判若两人引热议',
    slug: 'nvxing-suyan-caishichang',
    category: 'celebrity',
    categoryName: '明星八卦',
    summary: '路人拍摄的照片在网络疯传，网友纷纷表示不敢相信这是同一个人，该女星工作室暂未回应。',
    content: '详细内容待补充...',
    coverImage: 'https://readdy.ai/api/search-image?query=Candid%20street%20photography%20style%20scene%20at%20busy%20market%2C%20casual%20atmosphere%2C%20natural%20lighting%2C%20paparazzi%20style%20shot%2C%20warm%20tones%2C%20everyday%20life%20vibe%2C%20editorial%20documentary%20photography&width=800&height=600&seq=article-cover-07&orientation=landscape',
    tags: ['女星', '素颜', '反差'],
    views: 189200,
    hot: 95,
    isFeatured: false,
    isDaily: true,
    publishDate: '2026-07-03',
  },
  {
    id: 8,
    title: '某情侣博主被曝早已分手，为维持商业合作继续假扮恩爱',
    slug: 'qinglv-bozhu-fenshou-jiafen',
    category: 'influencer',
    categoryName: '网红爆料',
    summary: '知情人士称两人在半年前就已分手，但为了不违约继续合体接广告，每条情侣视频收入高达六位数。',
    content: '详细内容待补充...',
    coverImage: 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20happy%20couple%20on%20social%20media%20screen%20versus%20cold%20distant%20reality%2C%20contrast%20between%20online%20and%20offline%2C%20modern%20social%20media%20critique%2C%20editorial%20style%2C%20dramatic%20lighting&width=800&height=600&seq=article-cover-08&orientation=landscape',
    tags: ['情侣', '商业合作', '假恩爱'],
    views: 132600,
    hot: 90,
    isFeatured: true,
    isDaily: false,
    publishDate: '2026-07-03',
  },
];

export const featuredArticles = articles.filter(a => a.isFeatured);
export const dailyArticles = articles.filter(a => a.isDaily);

export const testimonials = [
  {
    id: 1,
    name: '吃瓜小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20portrait%2C%20neutral%20expression%2C%20clean%20light%20background%2C%20professional%20headshot%20style%2C%20soft%20lighting&width=80&height=80&seq=avatar-01&orientation=squarish',
    role: '资深吃瓜群众',
    rating: 5,
    content: '51黑料网真的是我每天必刷的网站！每次都能第一时间吃到最新鲜的瓜，比微博热搜还快，吃瓜群众必备神器！',
  },
  {
    id: 2,
    name: '八卦研究员',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20portrait%20of%20young%20person%2C%20friendly%20expression%2C%20clean%20light%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting&width=80&height=80&seq=avatar-02&orientation=squarish',
    role: '娱乐博主',
    rating: 5,
    content: '作为娱乐博主，这里是我最重要的信息来源之一。爆料速度惊人，而且内容真实度很高，已经推荐给所有同行了！',
  },
  {
    id: 3,
    name: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20portrait%2C%20casual%20expression%2C%20clean%20light%20background%2C%20professional%20headshot%20style%2C%20soft%20warm%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish',
    role: '忠实用户',
    rating: 5,
    content: '每天睡前必刷一遍51黑料网，已经成了我的生活习惯。有时候刷到凌晨都停不下来，料实在太猛了！',
  },
  {
    id: 4,
    name: '娱乐圈观察家',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20portrait%2C%20thoughtful%20expression%2C%20clean%20light%20background%2C%20professional%20headshot%20style%2C%20soft%20studio%20lighting&width=80&height=80&seq=avatar-04&orientation=squarish',
    role: '行业从业者',
    rating: 5,
    content: '这个网站的深度分析文章非常有料，很多行业内幕都是在这里第一次看到的，比同行掌握的信息都要多。',
  },
  {
    id: 5,
    name: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20portrait%2C%20cheerful%20expression%2C%20clean%20light%20background%2C%20professional%20headshot%20style%2C%20soft%20bright%20lighting&width=80&height=80&seq=avatar-05&orientation=squarish',
    role: '大学生',
    rating: 4,
    content: '我们宿舍四个人都在看！每天课间都在讨论上面看到的新爆料，已经成为校园八卦的主要来源了。',
  },
  {
    id: 6,
    name: '理性吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20portrait%2C%20calm%20expression%2C%20clean%20light%20background%2C%20professional%20headshot%20style%2C%20soft%20even%20lighting&width=80&height=80&seq=avatar-06&orientation=squarish',
    role: '自媒体人',
    rating: 5,
    content: '内容质量很高，不是那种标题党的垃圾网站。每篇文章都有理有据，吃瓜也能吃得明明白白。',
  },
];

export const stats = [
  { value: '500万+', label: '月活跃用户' },
  { value: '10万+', label: '独家爆料累计' },
  { value: '98%', label: '用户满意度' },
];

export const faqs = [
  {
    question: '51黑料网的内容来源可靠吗？',
    answer: '我们拥有遍布娱乐圈的独家信息渠道网络，所有内容均经过多方交叉验证后发布。作为黑料吃瓜第一站，我们始终坚持真实、客观、公正的原则，确保每一条爆料都有据可查。',
  },
  {
    question: '如何第一时间获取最新爆料？',
    answer: '您可以将51黑料网官网加入浏览器收藏夹，或关注我们的社交媒体账号。我们提供24小时不间断更新服务，每日大赛正能量内容全天候推送，黑料不打烊，让您永远不会错过任何精彩内容。',
  },
  {
    question: '网站上的内容多久更新一次？',
    answer: '51黑料网实行24小时滚动更新机制，编辑团队全天候监控娱乐圈动态。热门事件发生后，我们通常在30分钟内就能发布第一手信息，全网资源整合速度领先同行。',
  },
  {
    question: '可以投稿或提供爆料线索吗？',
    answer: '当然可以！我们非常欢迎广大吃瓜群众提供独家线索。您可以通过关于我们页面的联系方式与我们取得联系，所有线索提供者信息将严格保密。',
  },
  {
    question: '51黑料网有手机APP吗？',
    answer: '目前您可以通过手机浏览器直接访问我们的官网，网站已全面适配移动端。APP正在紧锣密鼓地开发中，敬请期待！',
  },
];